<div class="client-payment-profile-list--container">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>
  <div
    class="
      client-payment-profile-list--header flex justify-space-between align-items-center
    "
  >
    <div class="text-large">Payment Profile</div>
    <button
      type="button"
      class="lum-button"
      (click)="onOpenCardForm()"
      [disabled]="noPaymentGatewaySettings"
      [matTooltip]="toolTipMessage"
    >
      <i class="fas fa-plus mr-2"></i> Add Card
    </button>
  </div>
  <div class="client-payment-profile-list--content pt-4">
    <lum-client-payment-profile-table
      [cards]="creditCards"
      [client]="client"
      (setDefaultCardEvent)="onSetDefaultCard($event)"
      (openPaymentProfileFormEvent)="onManageCard($event)"
    ></lum-client-payment-profile-table>

    <mat-paginator
      [length]="(pagination$ | async)?.total"
      [pageSize]="(pagination$ | async)?.per_page"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      [pageIndex]="((pagination$ | async)?.current_page || 1) - 1"
      (page)="onPaginationEvent($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</div>
